export default __webpack_public_path__ + "static/media/drinks.322867ad.svg";